<template>
  <div style="flex: 1; margin: 5px;" @click="click">
    <div><img :src="thumbnailUrl" width="100%" /></div>
    <div class="farm-name">{{ farmName }}</div>
    <div class="font-weight-bold flower-specie-name">{{ flowerSpecieName }}</div>
  <div></div>
  </div>
</template>

<script>
export default {
  props: {
    flower: {
      type: Object,
      default: null
    },
    onClick: {
      type: Function
    }
  },
  computed: {
    farmName() {
      return this.flower ? this.flower.farm.name : "";
    },
    flowerSpecieName() {
      return this.flower ? this.flower.flower_specie.name : "";
    },
    thumbnailUrl() {
      return this.flower ? this.flower.images[0].image_url : "";
    }
  },
  methods: {
    click() {
      if (this.onClick) {
        this.onClick(this.flower.id);
      }
    }
  }
};
</script>

<style lang="scss">
.title {
  color: #191D38;
}

.farm-name {
  color: #999;
  font-size: 10px;
}

.flower-specie-name {
  color: #191D38;
  font-size: 12px;
}
</style>
